module.exports = __webpack_public_path__ + "img/Icon-Done copy.635a9b5e.svg";